import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      order: 1,
    },
    infoWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: SMALL_MARGIN,
    },
    title: {
      fontWeight: 'bold',
      fontSize: 22,
      lineHeight: 1.2,
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
        cursor: 'text',
      },
    },
    subtitle: {
      fontSize: 14,
      lineHeight: 1,
      color: colorsPalette.gray,
      fontWeight: 'bold',
      marginBottom: 10,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
        cursor: 'text',
        marginBottom: '0',
      },
    },
    expandIcon: {
      width: 16,
      height: 16,
      transition: 'transform 0.3s ease-out',
      transform: 'rotate(180deg)',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    progressWrap: {
      position: 'relative',
      width: '100%',
      height: 5,
      background: 'rgba(134, 134, 241, 0.364706)',
      borderRadius: 5,
    },
    progress: {
      position: 'absolute',
      background: colorsPalette.violet,
      borderRadius: 5,
      height: 5,
      left: 0,
      top: 0,
    },
    progressList: {
      paddingLeft: 0,
      margin: 0,
      paddingBottom: MIDDLE_MARGIN,
      borderBottom: `1px solid ${colorsPalette.violetAnalyticsCard}`,
    },
    accordionRoot: {
      background: 'transparent',
      boxShadow: 'none',
      '&$accordionDisabled': {
        background: 'transparent',
        pointerEvents: 'auto',
      },
    },
    accordionDisabled: {},
    summaryRoot: {
      padding: 0,
      '&$summaryDisabled': {
        opacity: 1,
        pointerEvents: 'auto',
        userSelect: 'auto',
      },
    },
    summaryContent: {
      display: 'flex',
      flexDirection: 'column',
      margin: 0,
      marginBottom: MIDDLE_MARGIN,
      '&$summaryExpanded': {
        margin: 0,
        marginBottom: MIDDLE_MARGIN,
      },
    },
    summaryExpanded: {
      '& $expandIcon': {
        transform: 'none',
      },
      '&$summaryDisabled': {
        opacity: 1,
      },
    },
    summaryDisabled: {},
    detailsRoot: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  }),
);

export default useStyles;
